import { styled } from '@mui/material/styles';

interface StyledTextAreaWrapperProps {
  isRtl?: boolean;
}

export const StyledTextAreaWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isRtl',
})<StyledTextAreaWrapperProps>(({ isRtl }) => ({
  transform: isRtl ? 'translateX(8px)' : 'translateX(-8px)',
}));
